<!--
    Styles
-->

<style>

</style>



<!--
    Template
-->

<template>
    <div />
</template>



<!--
    Scripts
-->

<script>

    import {mapActions} from 'vuex';

    export default {

        methods: mapActions('session', [
            'create',
        ]),

        async mounted () {
            const {token, refresh_token} = this.$route.query;
            await this.create({jwt: token, refresh: refresh_token});
            this.$router.replace('/');
        }

    }

</script>
